export enum EgiErrorCode {
  Default = 0,
  UpamAuthFailure = 20_401,
  EmailPasswordCombinationInvalid = 20_402,
  EmailNotFound = 20_403,
  PasswordInvalid = 20_404,
  PasswordNotSet = 20_405,
  UserAccountNotVerified = 20_408,
  UserAccountSoftDeleted = 20_412,
  // 20_413 t/m 20_415 waren de verwijderde reset-op-geboortejaar-codes; nummers niet hergebruiken
  RegistrationClosed = 20_416,
  RegistrationKeyInvalid = 20_417,
  RegistrationNotPossible = 20_418,
  EmailServiceUnavailable = 20_419,
  UserAccountAlreadyExists = 20_421,
  // Platformmodi (issue #51): PlatformModeInterceptor handelt ze af
  PlatformUnavailable = 20_422,
  PlatformReadOnly = 20_423,
  RefreshTokenNotFound = 20_409,
  RefreshTokenNotProvided = 20_410,
  InvalidRefreshToken = 20_411,
  BadgeHexNotFound = 20_406,
  BadgeNotLinkedToUserAccount = 20_407,
  TimesheetIssue = 21_000,
  TimesheetEntryOverlaps = 21_001,
  TimesheetPeriodExceedsThreshold = 21_002,
  CannotInsertBeforeTimesheetEntry = 21_003,
  CanInsertBeforeMinTimestampPreceded = 21_004,
  CanInsertBeforeMaxTimestampExceeded = 21_005,
  TimesheetsForDayMismatch = 21_006,
  TimesheetEntriesRequired = 21_007,
  StartMustPrecedeEndException = 21_008,
  InsertBeforePeriodNotFound = 21_009,
  TimesheetEntryNotFound = 21_010,
  EndCannotExceedNextStart = 21_011,
  StartCannotPrecedePreviousEnd = 21_012,
  InsertBeforeEntryNotFound = 21_013,
  MissingTimeGap= 21_015
}
